import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Theme from './services/theme';
import Header from './components/partials/header';
import SideBar from './components/partials/sidebar';
import Content from './components/partials/content';
import ErrorBoundary from './components/partials/error-boundary';
import {
  ToggleNavBarProvider,
  LoadingBarProvider,
  MessageContextProvider
} from './libraries/contexts';
import UserService from './services/user-service';
import PersistenceService from './services/persistence-service';
import SnackBar from './components/partials/snackbar';

const mainContent = props => {
  return (
    <div className="app">
      <ToggleNavBarProvider>
        <LoadingBarProvider>
          <Header />
          <SideBar />
          <Content />
          <SnackBar />
        </LoadingBarProvider>
      </ToggleNavBarProvider>
    </div>
  );
};

const App = props => {
  const onVisibilitychange = event => {
    const user = UserService.getCurrentUser();
    const token = PersistenceService.get('token');
    if (user && token && token !== user.token) {
      window.location.assign('/');
    }
  };

  const storageHandler = event => {
    UserService.IsLogged();
  };
  useEffect(() => {
    window.addEventListener('visibilitychange', onVisibilitychange);
    window.addEventListener('storage', storageHandler, false);
    return () => {
      window.removeEventListener('visibilitychange', onVisibilitychange);
    };
  }, []);

  return (
    <MessageContextProvider>
      <div className="notranslate">
        <MuiThemeProvider theme={Theme}>
          <Router>
            <ErrorBoundary>
              <CssBaseline />
              {mainContent()}
            </ErrorBoundary>
          </Router>
        </MuiThemeProvider>
      </div>
    </MessageContextProvider>
  );
};

export default App;
